import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=a7643bfa&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=ts&"
export * from "./Voucher.vue?vue&type=script&lang=ts&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=a7643bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7643bfa",
  null
  
)

export default component.exports